// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"modulesEditTab_buttonsContainer__s1TUl"};